export default {"src":"https://cdc-market-assets.crypto.com/_next/static/media/account-user.d711ad85.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};